"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _featuredToutContent = _interopRequireDefault(require("../featured-tout-content"));

var _excluded = ["image", "body", "footer", "title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Tout body content */
  body: _propTypes.node,

  /** Tout footer content */
  footer: _propTypes.node,

  /** Tout img src url */
  image: _propTypes.string,

  /** Tout title content */
  title: _propTypes.node
};
/**
 * FeaturedTout is a generic grouping of content that includes an image, title,
 * body content, and footer. The component is a two column layout with the
 * image in the first and all other content in the second. An alternative
 * component exists to handle a single column layout with similar content.
 * Root element is [Flex]() and accepts all compatible props.
 */

var FeaturedTout = function FeaturedTout(_ref) {
  var image = _ref.image,
      body = _ref.body,
      footer = _ref.footer,
      title = _ref.title,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    px: 3,
    width: 1 / 2
  }, props), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    width: 1 / 5
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Image, {
    src: image,
    width: 1
  })), /*#__PURE__*/_react["default"].createElement(_featuredToutContent["default"], {
    body: body,
    footer: footer,
    pl: 1,
    title: title,
    width: 4 / 5
  }));
};

FeaturedTout.propTypes = propTypes;
var _default = FeaturedTout;
exports["default"] = _default;